import React, { Component } from "react";
import { FiSettings } from "react-icons/fi";
import { FaLink, FaShippingFast, FaWallet } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";
import { MdSettings } from "react-icons/md";
import ShopIcon from "../micro/ShopIcon";
import TermsIcon from "../micro/TermsIcon";
import { BsHandbagFill } from "react-icons/bs";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopDetailModal: false,
      shopUid: window.location.pathname.split("/")[2],
    };
  }

  render() {
    return (
      <div>
        <header className="row mx-0 px-3 py-3">
          <div className="col align-self-center">
            <span
              className="color-main fw-bold"
              onClick={() => this.setState({ shopDetailModal: true })}
            >
              ویرایش فروشگاه
            </span>
          </div>
          <div className="col-auto align-self-center">
            <Link
              to={{
                pathname: "/setting?seller=1",
              }}
            >
              <FiSettings size="28" />
            </Link>
          </div>
        </header>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.state.shopDetailModal}
          toggle={() => this.setState({ shopDetailModal: false })}
        >
          <ModalBody className="row mx-0 px-4 py-3">
            <div className="col-12 px-0 py-3 align-self-center fw-bold">
              <Link to={`/dashboard/${this.state.shopUid}/edit`}>
                <span className="ms-3">
                  <ShopIcon size={28} color={"fill-dark"} />
                </span>
                <span>اطلاعات فروشگاه</span>
              </Link>
            </div>
            <div className="col-12 px-0 py-3 align-self-center fw-bold">
              <Link to={`/dashboard/${this.state.shopUid}/terms`}>
                <span className="ms-3">
                  <TermsIcon size={28} color={"fill-dark"} />
                </span>
                <span>توضیحات تکمیلی و قوانین</span>
              </Link>
            </div>
            <Link
              to={`/dashboard/${this.state.shopUid}/shopping-configs`}
              className="px-0"
            >
              <div className="col-12 px-0 py-3 align-self-center fw-bold">
                <BsHandbagFill className="ms-3 fill-dark" size={28} />
                <span>تنظیمات خرید</span>
              </div>
            </Link>
            <Link
              to={`/dashboard/${this.state.shopUid}/managers`}
              className="px-0"
            >
              <div className="col-12 px-0 py-3 align-self-center fw-bold">
                <MdSettings className="ms-3 fill-dark" size={28} />
                <span>مدیران فروشگاه</span>
              </div>
            </Link>
            <Link
              to={`/dashboard/${this.state.shopUid}/connections`}
              className="px-0"
            >
              <div className="col-12 px-0 py-3 align-self-center fw-bold">
                <FaLink className="ms-3 fill-dark" size={28} />
                <span>ارتباطات فروشگاه</span>
              </div>
            </Link>
            <Link
              to={`/dashboard/${this.state.shopUid}/posting-methods`}
              className="px-0"
            >
              <div className="col-12 px-0 py-3 align-self-center fw-bold">
                <FaShippingFast className="ms-3 fill-dark" size={28} />
                <span>مدیریت ارسال فروشگاه</span>
              </div>
            </Link>
            <Link
              to={`/dashboard/${this.state.shopUid}/payments`}
              className="px-0"
            >
              <div className="col-12 px-0 py-3 align-self-center fw-bold">
                <FaWallet className="ms-3 fill-dark" size={26} />
                <span>شیوه های پرداخت</span>
              </div>
            </Link>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Header;
